import { render, staticRenderFns } from "./ListDatasets.vue?vue&type=template&id=6d46e33e"
import script from "./ListDatasets.vue?vue&type=script&lang=js"
export * from "./ListDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports